<tax-cto-detail-header
  [contract]="contract"
  [componentTitle]="'cto.kkm.history'"
  (contractUpdated)="getContract(contract.id)"
></tax-cto-detail-header>

<!--TODO: fix $any-->
<ng-container *ngIf="$any(retailPlaceData?.kkms)[0] as kkm">
  <div>
    <div class="layout-2-columns">
      <svg-icon key="kkt"></svg-icon>
      <div>{{ kkm.internalName }}</div>
    </div>
    <div class="kkm-info">
      <div class="grey-text">
        <span>{{ retailPlaceData?.address }}</span>
      </div>
      <div class="grey-text">
        <span>{{ kkm.model }}</span>
        <span *ngIf="kkm.year" translate>
          {{ 'cto.kkm.release' | translate }} {{ retailPlaceData.kkms[0].year }}
        </span>
      </div>
      <div class="grey-text">
        <span>{{ 'cto.add.kkm.number' | translate }} {{ kkm.serialNumber }}</span>
        <span *ngIf="kkm.fnsKkmId"> {{ 'cto.kkm.rnm' | translate }} {{ kkm.fnsKkmId }} </span>
        <span>ID: {{ kkm.id }}</span>
      </div>
    </div>
  </div>
  <div class="ui-kit-tag-list">
    <div
      class="ui-kit-tag"
      *ngFor="let tag of tags"
      [ngClass]="{ tag__selected: selectedTags.includes(tag) }"
      (click)="selectTag(tag)"
    >
      <span translate>{{ tag }}</span>
    </div>
  </div>

  <div class="content">
    <ng-container *ngFor="let event of getFilteredHistory(kkmHistory)">
      <div class="content-item">
        <span translate>{{ event.type }}</span>
        <!--TODO: fix $any-->
        <span>{{ $any(event).createdAt | dateTime }}</span>
      </div>
      <hr class="greyline" />
    </ng-container>
  </div>
</ng-container>
